import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Router} from '@angular/router';
import {CoreSidebarService} from '../../../@core/components/core-sidebar/core-sidebar.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UniversitySettingService} from '../../shared/services/university-setting.service';
import {Helper} from '../../shared/constants/helper';

@Component({
    selector: 'app-settings',
    templateUrl: './university-settings.component.html',
    styleUrls: ['./university-settings.component.scss']
})
export class UniversitySettingsComponent implements OnInit {
    showSearch = false;
    id: any;
    data: any;
    updatePasswordForm: FormGroup;
    inputTypePassword = 'password';
    submitted: any = false;
    submitting: any = false;
    searchForm: FormGroup;
    pagination = {
        page: 1,
        total: null,
        perpage: 15,
        pages: null
    };
    settings = [];
    years = Helper.getYearArray(2019);

    constructor(private router: Router,
                private _coreSidebarService: CoreSidebarService,
                public modalService: NgbModal,
                private fb: FormBuilder,
                private universitySettingService: UniversitySettingService) {
    }

    ngOnInit(): void {
        this.refresh();
    }

    refresh() {
        this.searchForm = this.fb.group({
            'session_year': [''],
            'session_name': [''],
            'student_application_id_prefix': ['']
        });
        this.get();
    }

    toggleSidebar(): void {
        this._coreSidebarService.getSidebarRegistry('add-setting').toggleOpen();
    }

    add(): void {
        this.data = undefined;
        this.toggleSidebar();
    }

    getData(valueSubmit: any): void {
        if (valueSubmit) {
            this.get({page: 1, total: null, perpage: 15, pages: null});
        }
        this.toggleSidebar();
    }

    get(params: any = {}) {
        params.page = this.pagination.page;
        params.per_page = this.pagination.perpage;
        this.submitting = true;
        this.settings = [];
        this.universitySettingService.get(params).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.settings = data['data'];
                this.pagination = {
                    page: data.current_page,
                    total: data.total,
                    perpage: data.per_page,
                    pages: data.last_page,
                };
            } else {
                this.settings = [];
            }
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }

    search() {
        const params = {
            'session_year': (this.searchForm.value && this.searchForm.value.session_year) ? this.searchForm.value.session_year : '',
            'session_name': (this.searchForm.value && this.searchForm.value.session_name) ? this.searchForm.value.session_name : '',
            'student_application_id_prefix': (this.searchForm.value && this.searchForm.value.student_application_id_prefix) ? this.searchForm.value.student_application_id_prefix : '',
        };
        this.get(params);
    }

    onPageChange(page) {
        this.pagination.page = page;
        const params = {
            'session_year': (this.searchForm && this.searchForm.value && this.searchForm.value.session_year) ? this.searchForm.value.session_year : '',
            'session_name': (this.searchForm && this.searchForm.value && this.searchForm.value.session_name) ? this.searchForm.value.session_name : '',
            'student_application_id_prefix': (this.searchForm && this.searchForm.value && this.searchForm.value.student_application_id_prefix) ? this.searchForm.value.student_application_id_prefix : '',
        };
        this.get(params);
    }

    edit(data) {
        this.data = data;
        this.toggleSidebar();
    }

    updateStatus(status, data) {
        this.submitted = true;
        if (this.submitted) {
            const params = {
                'status': status
            };
            this.submitting = true;
            this.universitySettingService.updateStatus(data.id, params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.id = undefined;
                this.modalService.dismissAll('');
                this.get();
            }, error => {
                this.submitting = false;
                this.submitted = false;
                this.id = undefined;
            });
        }
    }

    backSessionEntry(data) {
        this.submitted = true;
        console.log('data', data);
        this.router.navigateByUrl('university-setting/' + data.id + '/back-session-entry');
        /*if (this.submitted) {
            const params = {
                'status': status
            };
            this.submitting = true;
            this.universitySettingService.updateStatus(data.id, params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.id = undefined;
                this.modalService.dismissAll('');
                this.get();
            }, error => {
                this.submitting = false;
                this.submitted = false;
                this.id = undefined;
            });
        }*/
    }

    setDefaultSession(data, e) {
        this.submitted = true;
        if (this.submitted) {
            const params = {
                'session_default': e
            };
            this.submitting = true;
            this.universitySettingService.defaultSession(data.id, params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.get();
            }, error => {
                this.submitting = false;
                this.submitted = false;
            });
        }
    }

    reRegistrationStatus(data, e) {
        this.submitted = true;
        if (this.submitted) {
            const params = {
                're_registration_status': e
            };
            this.submitting = true;
            this.universitySettingService.reRegistrationStatus(data.id, params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.get();
            }, error => {
                this.submitting = false;
                this.submitted = false;
            });
        }
    }
}
